
<div>
  <br>
    <div [hidden]="!ShowCompletedApplications" >
      <mat-toolbar class="form-toolbar"
        fxShow.gt-sm fxHide.lt-md>
        <span class="form-action-title">
          APPLICATIONS COMPLETED
        </span>

      </mat-toolbar>
      <div fxHide.gt-sm fxShow.lt-md>
        <div>
          <div class="form-action-title">APPLICATIONS COMPLETED</div>

        </div>
        <mat-divider></mat-divider>
      </div>
      <div [hidden]="!toggleDisplayCardList">
        <div fxLayout="row wrap" fxLayout.xs="column wrap" style="margin-top: 18px;">
          @for (application of data; track application) {
            <div fxFlex.gt-xs="50%" [fxFlex.gt-md]="cardLayout">
              <div style="margin-top: 10px; margin-right: 10px;">
                <mat-card [class.mat-elevation-z7]='true'>
                  <!-- Card Title -->
                  <mat-card-title style="font-size: 16px;">{{application.name}}</mat-card-title>
                  <mat-divider></mat-divider>
                  <!-- Card Body -->
                  <div style="margin-top: 32px !important">
                    <mat-card-content>
                      <div>
                        <span>
                          <span class="card-label">Program</span>
                          <span class="card-value">
                            {{application._Ebb_ProgramCycleId_Formatted}}
                            <br>
                              <span class="card-value-light">
                                (accepted {{getFormattedDate(application.acceptedDate.toString())}})
                              </span>
                            </span>
                          </span>
                        </div>
                        <div style="margin-top: 9px;">
                          @if (application.stateCode === 1) {
                            <div>
                              <span class="card-label">Status</span>
                              <div>
                                @switch (application.statusCode) {
                                  @case (700000000) {
                                    <div class="card-value">
                                      <span class="accent-text">
                                        Paid
                                      </span>
                                    </div>
                                  }
                                  @case (700000001) {
                                    <div class="card-value">
                                      <span class="accent-text">
                                        Withdrawn
                                      </span>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                          @if (application.stateCode === 0) {
                            <div>
                              <span>
                                <span class="card-label">Status</span>
                                <span class="card-value">
                                  {{application.stateCodeOptionSet}}
                                  <span class="card-value-light">
                                    ({{application.statusCodeOptionSet}})
                                  </span>
                                </span>
                              </span>
                            </div>
                          }
                        </div>
                        <div style="margin-top: 9px;">
                          <span>
                            <span class="card-label">Homeowner</span>
                            <span class="card-value">
                              {{application._Ebb_OwnerId_Formatted}}
                            </span>
                          </span>
                        </div>
                      </mat-card-content>
                    </div>
                    <mat-divider></mat-divider>
                    <!-- Card Actions -->
                    <mat-card-actions>
                      @if (checkUserAuthorization(application.stateCode, application.contractorPermissionsCode) === 1) {
                        <div>
                          <button mat-stroked-button color="primary" (click)="onClickOpenApplication(application.id)">
                            VIEW
                          </button></div>
                        }
                      </mat-card-actions>
                    </mat-card>
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="mat-elevation-z7" style="width: 100%" [hidden]="toggleDisplayCardList">

            <table mat-table [dataSource]="dataSource" matSort matSortActive="_Ebb_OwnerId_Formatted" matSortDirection="asc" style="width: 100%">

              <ng-container matColumnDef="_Ebb_OwnerId_Formatted">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Owner Name </th>
                <td mat-cell width="20%;" *matCellDef="let item">
                  <span style="font-size: 14px;">
                    {{item._Ebb_OwnerId_Formatted}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="applicationNumber">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Application number </th>
                <td mat-cell width="8%;" *matCellDef="let item">
                  <span style="font-size: 14px;">
                    {{item.applicationNumber}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell width="25%;" *matCellDef="let item">
                  <span style="font-size: 14px;">
                    {{item.name}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="acceptedDate">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Accepted date </th>
                <td mat-cell width="10%;" *matCellDef="let item">
                  <span style="font-size: 14px;">
                    {{getFormattedDate(item.acceptedDate.toString())}}
                  </span>
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="RetrofitDue">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Phase Due Date </th>
              <td mat-cell width="8%;" *matCellDef="let item">
                <div *ngIf="item.stageCode === 700000000">
                  <span style="font-size: 12px;">

                    {{getFormattedDate(item.preRetrofitDue.toString())}}
                  </span>

                </div>
                <div *ngIf="item.stageCode === 700000001">
                  <span style="font-size: 12px;">

                    {{getFormattedDate(item.postRetrofitDue.toString())}}
                  </span>

                </div>

              </td>
            </ng-container> -->

            <ng-container matColumnDef="_Ebb_ProgramCycleId_Formatted">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Program </th>
              <td mat-cell width="20%;" *matCellDef="let item">
                <span style="font-size: 12px;">
                  @if (item) {
                    <div>
                      {{item._Ebb_ProgramCycleId_Formatted}}
                    </div>
                  }
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="_EBB_ProgramType">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
              <td mat-cell width="10%;" *matCellDef="let item">
                <span style="font-size: 12px;">
                  @if (item) {
                    <div>
                      {{programTypeDesc(item.programType)}}
                    </div>
                  }
                </span>
              </td>
            </ng-container>


            <ng-container matColumnDef="displaystatus">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell width="15%;" *matCellDef="let item">
                <span style="font-size: 14px;">
                  @if (item.stateCode === 1) {
                    <div>
                      <div>
                        @switch (item.statusCode) {
                          @case (700000000) {
                            <div class="card-value">
                              <span style="color: #2a7f48;">
                                {{item.displaystatus}}
                              </span>
                            </div>
                          }
                          @case (700000001) {
                            <div class="card-value">
                              <span style="color: #2a7f48;">
                                {{item.displaystatus}}
                              </span>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th scope="col" mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell width="15%;" *matCellDef="let item">
                @if (checkUserAuthorization(item.stateCode, item.contractorPermissionsCode) === 1) {
                  <div>
                    <button mat-stroked-button color="primary" (click)="onClickOpenApplication(item.id)">
                      VIEW
                    </button>
                  </div>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator #dataPaginator="matPaginator" [length]="dataSourceLength" [pageSizeOptions]="tablePageSizeOptions">
          </mat-paginator>
        </div>


      </div>


    </div>